import moment from 'moment';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Form, FormFeedback, FormGroup, Input} from 'reactstrap';
import trainingPhasesActionCreators from '../../../store/training-phases/action-creators/index';
import Checkbox from '../../../../shared/forms/Checkbox';
import RejectStepSelect from './RejectStepSelect';

class ApproveThreeForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: false,
      approvedThreeAt: null,
      comment: '',
      isReject: false,
      rejectStep: 'author'
    };
  }

  // ----------------------
  // Methods
  // ----------------------

  handleInput() {
    const state = !this.state.isChecked
      ? {isChecked: true, approvedThreeAt: new Date()}
      : {isChecked: false, approvedThreeAt: null};
    this.setState({...state, isReject: false});
  }

  setReject(event) {
    this.setState({
      isReject: event.target.checked,
      isChecked: false
    })
  }

  setRejectStep(rejectStep) {
    this.setState({
      rejectStep
    })
  }

  handleSubmit(event) {
    event.preventDefault();

    if (this.state.isReject && !this.state.comment) {
      return;
    }

    if (this.state.isChecked) {
      const formData = {
        approvedThreeAt: this.state.approvedThreeAt,
        guid: this.props.reportGuid,
        comment: this.state.comment
      };
      this.props.approveThreeReport(formData);
    } else {
      this.props.rejectReport({
        reason: this.state.comment,
        guid: this.props.reportGuid,
        step: this.state.rejectStep,
      })
    }
  }

  setRejectComment(comment) {
    this.setState({
      comment: comment
    })
  }
  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Form noValidate onSubmit={event => this.handleSubmit(event)}>
        <FormGroup>
          <Checkbox
            label="Approve"
            name="approve_three"
            onChange={() => this.handleInput()}/>

          {!this.props.userContext.hasScope('oit') && (
            <Checkbox
              label="Reject"
              name="approve"
              checked={this.state.isReject}
              onChange={(e) => this.setReject(e)}/>
          )}
        </FormGroup>

        {this.state.isReject && (
          <RejectStepSelect
            value={this.state.rejectStep}
            onChange={(rejectStep) => this.setRejectStep(rejectStep)}
          />
        )}

        <FormGroup>
          <Input
            type="textarea"
            placeholder={this.state.isReject ? "Reject note" : "Note"}
            value={this.state.comment}
            onChange={(event) => this.setRejectComment(event.target.value)}
          />

          {this.state.isReject && (
            <FormFeedback style={{ display: 'block' }}>The comment field is required</FormFeedback>
          )}
        </FormGroup>

        {this.state.approvedThreeAt &&
        <div>
          <label>
            {moment().format('HH:mm on MMM D, YYYY')}
          </label>
        </div>
        }
        {(this.state.isChecked || this.state.isReject) &&
        <button className="button primary">
          Submit
        </button>
        }
      </Form>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    userContext: state.common.userContext,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    approveThreeReport: (formData) => {
      dispatch(trainingPhasesActionCreators.approveThreeReport(formData));
    },
    rejectReport: (formData) => {
      dispatch(trainingPhasesActionCreators.rejectReport(formData))
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ApproveThreeForm);
